<template>
    <div>
        <v-data-table
            class="billing-guide-subscriptions-table"
            :headers="headers"
            :items="subscriptions"
            :items-per-page="500"
            hide-default-footer
            fixed-header
            :disable-pagination="true"
        >
            <template v-slot:item.plan_name="{ item }">
                <v-chip small>
                    {{ getPlanName(item) }}
                </v-chip>
            </template>
            <template v-slot:item.place="{ item }">
                <template v-if="canViewBusiness(item)">
                    <a
                      :href="getSingleBusinessUrl(item.place_id)"
                      target="_blank"
                    >
                      {{ item.place.name }}
                    </a>
                </template>
                <template v-else>
                    {{ item.place.name }}
                </template>
                <div v-if="item.place.location && item.place.location.shortFormattedAddress" class="caption">
                  {{ item.place.location.shortFormattedAddress }}
                </div>
            </template>
            <template v-slot:item.status="{ item }">
                <subscription-status
                    :subscription="item"
                    :show-cancel-option="hasPendingCancellation(item)"
                />
            </template>
            <template v-slot:item.started_at="{ item }">
                {{ fullDateFormat(item.data.started_at) }}
            </template>
            <template v-slot:item.amount="{ item }">
                <div class="text-no-wrap">
                    {{ item.formatted_pricing.sum_total }}
                </div>
            </template>
            <template v-slot:item.billing_cycle="{ item }">
                <div class="text-no-wrap">
                    {{ $t(`billing_cycle_${item.data.billing_cycle.interval}`) }}
                </div>
            </template>
            <template v-slot:item.next_billed_at="{ item }">
                <span v-if="item.data.current_billing_period && item.data.current_billing_period.ends_at">
                    {{ fullDateFormat(item.data.current_billing_period.ends_at) }}
                </span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.actions="{ item, index }">
                <div class="d-flex align-center">
                    <v-btn
                        class="text-decoration-underline text-capitalize cursor-pointer mr-2 billing-guide-subscription-details-btn"
                        :class="{ 'billing-guide-subscription-details-btn-first': index === 0 }"
                        :to="{ name: 'my-subscriptions.subscription-single', params: { id: item.id } }"
                    >
                        {{ $t('Details') }}
                    </v-btn>
                    <v-menu
                        v-if="canCancel(item)"
                        bottom
                        left
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                                icon
                                class="billing-guide-actions-activator"
                                :class="{ 'billing-guide-actions-activator-first': index === 0 }"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item
                                @click="$emit('cancel', item.id)"
                                class="billing-guide-cancel-action"
                                :class="{ 'billing-guide-cancel-action-first': index === 0 }"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="error">mdi-cancel</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="error--text">
                                    {{ $t('Cancel subscription') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { fullDateFormat } from '@/components/calendar/config';
import CurrencyMixin from '@/lib/CurrencyMixin';
import SubscriptionStatus from '@/components/subscriptions/SubscriptionStatus.vue';
import SubscriptionsMixin from '@/lib/SubscriptionsMixin';

export default {
  components: { SubscriptionStatus },
  mixins: [CurrencyMixin, SubscriptionsMixin],
  props: {
    subscriptions: {
      required: true,
      type: Array,
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t('Business'), value: 'place' },
        { text: this.$t('Plan name'), value: 'plan_name' },
        { text: 'Status', value: 'status' },
        { text: this.$t('Price'), value: 'amount' },
        { text: this.$t('Billing cycle'), value: 'billing_cycle' },
        { text: this.$t('Next billing'), value: 'next_billed_at' },
        { text: this.$t('First billing'), value: 'started_at' },
        { text: '', value: 'actions', sortable: false },
      ];
    },
  },
  methods: {
    fullDateFormat,
  },
};
</script>
